module.exports = __webpack_public_path__ + "img/check-circle-green.40f7a906.svg";